import axios from 'axios';
import { AuthKeys, AuthResponse } from './interfaces';

export async function getAuthKeys(prefix: string): Promise<AuthKeys[]> {
  const url = `${prefix}/shock-absorber-backend/auth/keys`;
  const { data } = await axios.get<AuthResponse>(url);
  return data.keys;
}
